



































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class DoKoFullscreenBtn extends Vue {
  rectStyle = {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "none",
  };
  // fill:#000000;fill-opacity:1;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1
  @Prop({
    type: String,
    default: "#f2f2f2",
  })
  private color!: string;

  @Prop({
    type: Number,
    default: 1248,
  })
  private x!: number;
  @Prop({
    type: Number,
    default: 0,
  })
  private y!: number;

  @Prop({
    type: Number,
    default: 32,
  })
  private s!: number;

  get cx() {
    return this.x + this.s / 2;
  }
  get cy() {
    return this.y + this.s / 2;
  }
  get edgeStart() {
    return this.x + this.s / 2 + this.s / 2 / 8;
  }

  get pathData() {
    console.log("pathData", this.edgeStart);
    return `M ${this.edgeStart},${this.y} h 14 v 14 h -4 v -10 h -10 z`;
  }

  over = false;

  get calcColor() {
    return this.over ? "#f00" : this.color;
  }

  fullscreen() {
    const elem = document.getElementById("app");

    if (elem && !document.fullscreenElement) {
      elem.requestFullscreen().catch((err) => {
        alert(
          `Error attempting to enable full-screen mode: ${err.message} (${err.name})`
        );
      });
    } else {
      document.exitFullscreen();
    }
  }
}
